import { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import ReactMarkdown from 'react-markdown';

function About() {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const carouselRef = useRef(null);

  useEffect(() => {
    if (window.$ && carouselRef.current) {
      window.$(carouselRef.current).owlCarousel({
        loop: true,
        margin: 30,
        autoplay: true,
        autoplayHoverPause: true,
        nav: true,
        dots: true,
        navText: [
          "<i className='fas fa-chevron-left'></i>",
          "<i className='fas fa-chevron-right'></i>",
        ],
        responsive: {
          0: { items: 1 },
          991: { items: 2 },
        },
      });
    }

    // Cleanup Owl carousel on unmount
    return () => {
      if (window.$ && carouselRef.current) {
        window
          .$(carouselRef.current)
          .trigger('destroy.owl.carousel')
          .removeClass('owl-carousel owl-loaded');
        window
          .$(carouselRef.current)
          .find('.owl-stage-outer')
          .children()
          .unwrap();
      }
    };
  }, []);

  useEffect(() => {
    const handleLoad = () => {
      setIsLoading(false);
    };

    window.addEventListener('load', handleLoad);
    return () => window.removeEventListener('load', handleLoad);
  }, []);

  return (
    <div>
      <div className="container block-padding pt-0">
        <div className="row">
          <div className="col-lg-6 my-auto">
            <h4>{t('aboutPage.about_us')}</h4>
            
            <ReactMarkdown
              components={{
                p: ({node, ...props}) => <p {...props} />,
                strong: ({node, ...props}) => <b {...props} />,
              }}
            >
              {t('aboutPage.description_combined')}
            </ReactMarkdown>
          </div>
          <div className="col-lg-6">
            <img
              src="/img/IMG_6310.JPG"
              alt=""
              className="img-fluid border-irregular1"
              data-aos="zoom-in"
            />
          </div>
        </div>
      </div>

      {/* <div className="bg-light-custom block-padding">
        <div className="container">
          <div id="counter" className="row">
            <div className="col-xl-3 col-md-6">
              <div className="counter">
                <i className="counter-icon fa fa-users"></i>
                <div className="counter-value" data-count="1500">
                  0
                </div>
                <h3 className="title">Happy Clients</h3>
              </div>
            </div>
            <div className="col-xl-3 col-md-6">
              <div className="counter">
                <i className="counter-icon flaticon-dog-in-front-of-a-man"></i>
                <div className="counter-value" data-count="14">
                  0
                </div>
                <h3 className="title">Professionals</h3>
              </div>
            </div>
            <div className="col-xl-3 col-md-6">
              <div className="counter">
                <i className="counter-icon flaticon-dog-2"></i>
                <div className="counter-value" data-count="900">
                  0
                </div>
                <h3 className="title">Adopted Pets</h3>
              </div>
            </div>
            <div className="col-xl-3 col-md-6">
              <div className="counter">
                <i className="counter-icon flaticon-prize-badge-with-paw-print"></i>
                <div className="counter-value" data-count="12">
                  0
                </div>
                <h3 className="title">Prizes</h3>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      {/* <div className="container bottom-block-padding">
        <h3 className="text-center">What our clients say</h3>
        <div className="col-md-12 mt-5">
          <div
            id="owl-testimonial"
            className="owl-carousel owl-theme"
            ref={carouselRef}
          >
            {testimonials.map(({ id, description, img, name, role }) => (
              <div className="testimonial" key={id}>
                <div className="content">
                  <p className="description">{description}</p>
                </div>
                <div className="testimonial-pic">
                  <img src={img} className="img-fluid" alt={name} />
                </div>
                <div className="testimonial-review">
                  <h5 className="testimonial-title">{name}</h5>
                  <span>{role}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div> */}
    </div>
  );
}

export default About;
